import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function AppErrorFallback({ eventId }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
          <CardDescription>
            An unexpected error occurred. Reloading the page usually fixes it.
          </CardDescription>
        </CardHeader>
        {eventId ? (
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Reference ID: <span className="font-mono">{eventId}</span>
            </p>
          </CardContent>
        ) : null}
        <CardFooter>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
